import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import "@features/Payment/css/PaymentPage.scss";
import { PaymentBalance } from "@features/Payment/CurrentBalance/PaymentBalance";
import { PaymentCardList } from "@features/Payment/ManageCards/PaymentCardList";
import { TransactionsHistoryList } from "@features/Payment/TransactionHistory/TransactionsHistoryList";
import { EJccFormTypes } from "@features/Payment/interface/IPayment";
import { useGetAccountDetails } from "@features/AccountDetails/hook/useGetAccountDetails";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";

export const PaymentPage = () => {
    const { t } = useTranslation("navigation");
    const [openedJccForm, setOpenedJccForm] = useState<EJccFormTypes>();
    const { accountDetails, accountDetailsState } = useGetAccountDetails();

    const setOpenedForm = (openedJccForm?: EJccFormTypes) => {
        setOpenedJccForm(openedJccForm);
    };

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" color="secondary" paragraph variant="h1">
                    {t("myPayments")}
                </Typography>
                <HandleErrorAndLoading error={accountDetailsState.error} isLoading={accountDetailsState.isLoading}>
                    {accountDetails && (
                        <Grid container data-testid="payment-children-grid" direction="column" spacing={4}>
                            <Grid item>
                                <PaymentBalance
                                    accountId={accountDetails.id}
                                    openedJccForm={openedJccForm}
                                    setOpenedJccForm={setOpenedForm}
                                />
                            </Grid>
                            <Grid item>
                                <PaymentCardList openedJccForm={openedJccForm} setOpenedJccForm={setOpenedForm} />
                            </Grid>
                            <Grid className="transaction-history" item>
                                <TransactionsHistoryList accountId={accountDetails.id} />
                            </Grid>
                        </Grid>
                    )}
                </HandleErrorAndLoading>
            </div>
        </Fragment>
    );
};
